import { GoogleAddressValidationApiState } from './types';

export const initialGoogleAddressValidationApiState: GoogleAddressValidationApiState = {
  addressValidationResult: null,
  isAddressValid: false,
};
